<template>

<div id="app">

  <Topbar/>

  <router-view></router-view>

  <Footer/>

</div>

</template>

<script>
import Topbar from './components/Topbar.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Topbar,
    Footer
  },
  methods: {
    setTitle: function() {
      document.title = 'Quantified Reading'
    },
    setMailChimpScript: function() {
      let mailChimpScript = document.createElement('script')
      mailChimpScript.setAttribute(
        'src',
        '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'
      )
      document.head.appendChild(mailChimpScript)
    }
  },
  mounted: function() {
    this.setTitle()
    this.setMailChimpScript()
  }
}
</script>

<style lang="scss" scoped>
#app {
  overflow: hidden;
}
</style>
